<template>
    <div>
        <el-row>
            <el-col :span="24">
                <Head>
                    <template v-slot:title>
                        <span style="margin-left:30%;"></span>
                    </template>
                </Head>
            </el-col>
        </el-row>
        <el-row class="row-top" type="flex" justify="center">
            <el-col :span="15">
                <flexible-job-list v-if="isShow" @statusFun="getStatus" :type="type"></flexible-job-list>
                <flexible-job-xq v-else @statusFun="getStatus" :item="itemData"></flexible-job-xq>
            </el-col>
        </el-row>


    </div>
</template>
<script>
import Head from '@/components/header/head.vue';
import flexibleJobList from '@/components/audit/audit_list.vue';
import flexibleJobXq from '@/views/audit/flexibleJob/flexibleJob_particulars.vue';
export default {
    data(){
        return {
            type:'2',

             isShow:true,
             itemData:[]
        }
    },
    methods:{
       getStatus(isShow,itemData){
        //    console.log(isShow)
           this.isShow = isShow
           if(itemData){
               this.itemData = itemData
           }

       }
    },
    components:{
        Head,
        flexibleJobList,
        flexibleJobXq
        
    }
}
</script>
<style lang="less" scoped>
        
</style>